<remote-update-domain-app-page-wrapper
  [data]="data()"
  [hasError]="hasError()"
  [emptyDescription]="emptyDescription"
  [emptyTitle]="emptyTitle"
  [isLoading]="loading() || isDownloadingDeviceRecordsFile()">
  <div header class="w-full items-center justify-between pt-150-rem">
    <div class="flex w-full justify-between items-center">
      <p class="text-[1.5rem] text-[#292F32] font-semibold">Devices</p>

      @if (isUpdateManager()) {<button
        [disabled]="isDownloadingDeviceRecordsFile()"
        (click)="onExportButtonClick()"
        mat-flat-button
        data-testid="export-dur-button">
        Export DUR</button
      >}
    </div>
    <div class="flex items-center gap-075-rem mt-100-rem">
      <form [formGroup]="form" (ngSubmit)="onSearch()" class="flex items-center gap-075-rem">
        <div class="w-110 relative">
          <input
            id="search"
            class="border h-11.25 rounded-full w-full placeholder-container-fg-muted text-body-lg-weight-regular bg-[#fff] px-250-rem border-input-border-default focus:outline-none focus:ring-0s"
            type="text"
            formControlName="search"
            placeholder="Search for Product ID"
            [class.error]="submitted && form.controls.search.invalid" />
          <div class="absolute top-1/2 left-5 transform -translate-y-1/2">
            <img src="/svgs/search.svg" alt="search" class="w-5 h-5" />
          </div>
          @if(submitted && form.controls.search.invalid){
          <div
            class="absolute flex gap-025-rem -bottom-200-rem left-3 w-full text-[13px] px-050-rem
            text-[#b91c1c]">
            <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
            Product ID is required
          </div>
          }
        </div>

        <div>
          <button mat-flat-button color="primary" type="submit">Search</button>
        </div>
      </form>
    </div>
  </div>
  <div content class="mt-350-rem">
    <remote-update-feature-remote-update-dashboard-devices-table
      (paginatorReady)="onPaginatorReady($event)"
      (pageChange)="onPageChange($event)"
      [devices]="data()">
    </remote-update-feature-remote-update-dashboard-devices-table>
  </div>
</remote-update-domain-app-page-wrapper>
